(() => {
  const SELECTOR = '[data-om-section]';

  function initSection(section) {
    if (!section || section.dataset.omReady === 'true') return;
    section.dataset.omReady = 'true';

    const mainImage = section.querySelector('.om-gallery__image');
    const thumbnails = section.querySelectorAll('[data-om-thumbnail]');
    const optionInputs = section.querySelectorAll('[data-om-option]');
    const variantInput = section.querySelector('[data-om-variant-id]');
    const variantData = section.querySelector('[data-om-variants]');
    const priceNodes = section.querySelectorAll('[data-om-price], [data-om-button-price], [data-om-mobile-price]');
    const addButton = section.querySelector('[data-om-add]');
    const addLabel = section.querySelector('[data-om-add-label]');
    const upload = section.querySelector('[data-om-upload]');
    const uploadLater = section.querySelector('[data-om-upload-later]');
    const uploadTitle = section.querySelector('[data-om-upload-title]');
    const uploadHint = section.querySelector('[data-om-upload-hint]');
    const form = section.querySelector('.om-form');
    const copy = {
      unavailable: section.dataset.omUnavailableLabel || 'Unavailable',
      soldOut: section.dataset.omSoldOutLabel || 'Sold out',
      uploadReadyHint: section.dataset.omUploadReadyHint || 'Photo ready · Click to replace',
      uploadLaterTitle: section.dataset.omUploadLaterTitle || 'We’ll email you after checkout',
      uploadLaterHint: section.dataset.omUploadLaterHint || 'No need to choose a photo right now',
      uploadRequiredTitle: section.dataset.omUploadRequiredTitle || 'Choose a photo—or send it later',
      uploadRequiredHint: section.dataset.omUploadRequiredHint || 'Select one option before adding to bag',
    };
    let variants = [];
    let activeVariant = null;

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.warn('Ollie & May portrait: variant data could not be read.', error);
      }
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage || thumbnail.classList.contains('is-active')) return;

        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
        mainImage.classList.add('is-changing');

        window.setTimeout(() => {
          mainImage.removeAttribute('srcset');
          mainImage.src = thumbnail.dataset.image;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.classList.remove('is-changing');
        }, 130);
      });
    });

    function selectedOptions() {
      const groups = section.querySelectorAll('[data-om-option-position]');
      return Array.from(groups).map((group) => {
        const checked = group.querySelector('[data-om-option]:checked');
        return checked ? checked.value : '';
      });
    }

    function updateVariant() {
      section.querySelectorAll('.om-choice').forEach((choice) => choice.classList.remove('is-selected'));
      optionInputs.forEach((input) => {
        if (input.checked) input.closest('.om-choice')?.classList.add('is-selected');
      });

      if (!variants.length || !variantInput) return;
      const options = selectedOptions();
      const variant = options.length
        ? variants.find((item) => item.options.every((value, index) => value === options[index]))
        : variants.find((item) => String(item.id) === String(variantInput.value)) || variants[0];

      if (!variant) {
        activeVariant = null;
        variantInput.value = '';
        variantInput.removeAttribute('value');
        addButton?.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = copy.unavailable;
        return;
      }

      activeVariant = variant;
      variantInput.value = String(variant.id);
      variantInput.setAttribute('value', String(variant.id));
      priceNodes.forEach((node) => { node.textContent = variant.price; });

      if (variant.image && mainImage && mainImage.src !== variant.image) {
        mainImage.removeAttribute('srcset');
        mainImage.src = variant.image;
        mainImage.alt = variant.imageAlt || mainImage.alt;
      }

      if (variant.available) {
        addButton?.removeAttribute('disabled');
        if (addLabel) addLabel.textContent = addLabel.dataset.defaultLabel || 'Add your portrait to bag';
      } else {
        addButton?.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = copy.soldOut;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (addLabel && !addLabel.dataset.defaultLabel) addLabel.dataset.defaultLabel = addLabel.textContent.trim();
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    if (upload) upload.required = false;

    if (upload && uploadTitle && uploadHint) {
      const initialTitle = uploadTitle.textContent;
      const initialHint = uploadHint.textContent;

      upload.addEventListener('change', () => {
        const file = upload.files?.[0];
        if (!file) return;
        if (uploadLater) uploadLater.checked = false;
        upload.required = false;
        upload.disabled = false;
        uploadTitle.textContent = file.name;
        uploadHint.textContent = copy.uploadReadyHint;
      });

      uploadLater?.addEventListener('change', () => {
        if (uploadLater.checked) {
          upload.value = '';
          upload.required = false;
          upload.disabled = true;
          uploadTitle.textContent = copy.uploadLaterTitle;
          uploadHint.textContent = copy.uploadLaterHint;
        } else {
          upload.disabled = false;
          upload.required = false;
          uploadTitle.textContent = initialTitle;
          uploadHint.textContent = initialHint;
        }
      });
    }

    form?.addEventListener('formdata', (event) => {
      if (activeVariant?.available) event.formData.set('id', String(activeVariant.id));
      const hasPhoto = upload && !upload.disabled && upload.files?.length > 0;
      if (hasPhoto) {
        event.formData.delete('properties[Send photo after checkout]');
      } else {
        event.formData.delete('properties[Pet photo]');
        event.formData.set('properties[Send photo after checkout]', 'Yes');
      }
    });

    form?.addEventListener('submit', (event) => {
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions()[index]));

      if (!variant || !variant.available || addButton?.disabled) {
        event.preventDefault();
        addButton?.focus();
        return;
      }

      activeVariant = variant;
      variantInput.value = String(variant.id);
      variantInput.setAttribute('value', String(variant.id));

      if (upload && !upload.files?.length) {
        if (uploadLater) uploadLater.checked = true;
        upload.required = false;
        upload.disabled = true;
        if (uploadTitle) uploadTitle.textContent = copy.uploadLaterTitle;
        if (uploadHint) uploadHint.textContent = copy.uploadLaterHint;
      }
    });

    updateVariant();
  }

  function initAll(root = document) {
    if (root.matches?.(SELECTOR)) initSection(root);
    root.querySelectorAll?.(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
